// extracted by mini-css-extract-plugin
module.exports = {"page":"page_page__BHkt4","content":"page_content__Dt_c4"};